import { render } from "./Sitemap-page.vue?vue&type=template&id=bb29246a&scoped=true"
import script from "./Sitemap-page.vue?vue&type=script&lang=js"
export * from "./Sitemap-page.vue?vue&type=script&lang=js"

import "./Sitemap-page.vue?vue&type=style&index=0&id=bb29246a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb29246a"]])

export default __exports__